import api from './api';

export async function getAgentHealth() {
  const response = await api.get('/api/agent/health');
  return response.data;
}

export async function createAgentPlan(prompt, tenantId) {
  const response = await api.post('/api/agent/plan', {
    prompt,
    ...(tenantId ? { tenantId } : {}),
  });
  return response.data;
}

export async function startAgentRun(planId) {
  const response = await api.post('/api/agent/run/start', { planId });
  return response.data;
}

export async function stopAgentRun(runId) {
  const response = await api.post('/api/agent/run/stop', { runId });
  return response.data;
}

export async function approveAgentStep(runId, stepIndex, approved) {
  const response = await api.post('/api/agent/run/approve', {
    runId,
    stepIndex,
    approved,
  });
  return response.data;
}

export async function pauseAgentRun(runId) {
  const response = await api.post('/api/agent/run/pause', { runId });
  return response.data;
}

export async function resumeAgentRun(runId) {
  const response = await api.post('/api/agent/run/resume', { runId });
  return response.data;
}

export async function getAgentRunState(runId) {
  const response = await api.get(`/api/agent/runs/${encodeURIComponent(runId)}/state`);
  return response.data;
}

export async function getAgentRunReplay(runId) {
  const response = await api.get(`/api/agent/runs/${encodeURIComponent(runId)}/replay`);
  return response.data;
}

export async function buildAgentEventsUrl(runId, apiBaseUrl) {
  const base = (apiBaseUrl || process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  const tokenRes = await api.post('/api/agent/sse-token', { runId });
  const streamToken = tokenRes?.data?.streamToken;
  if (!streamToken) {
    throw new Error('Failed to generate stream token');
  }

  const params = new URLSearchParams({ stream_token: streamToken });

  return `${base}/api/agent/runs/${encodeURIComponent(runId)}/events?${params.toString()}`;
}
